import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
  createRoutesFromElements,
  Route,
  ScrollRestoration,
} from "react-router-dom";
import { useTranslation } from 'react-i18next';
import './i18n/i18n';
import Footer from "./components/home/Footer/Footer";
import FooterBottom from "./components/home/Footer/FooterBottom";
import Header from "./components/home/Header/Header";
// import HeaderBottom from "./components/home/Header/HeaderBottom";
import About from "./pages/About/About";
import SignIn from "./pages/Account/SignIn";
import SignUp from "./pages/Account/SignUp";
import Cart from "./pages/Cart/Cart";
import Contact from "./pages/Contact/Contact";
import Home from "./pages/Home/Home";
import PrivacyPolicy from "./pages/Privacy/Privacy";
import Offer from "./pages/Offer/Offer";
import Payment from "./pages/payment/Payment";
import ProductDetails from "./pages/ProductDetails/ProductDetails";
import Shop from "./pages/Shop/Shop";
import Category from "./pages/Category/Category";
import OrderSuccess from "./pages/OrderSuccess/OrderSuccess";

const Layout = () => {
  const { i18n } = useTranslation();
  
  return (
    <div 
      dir={i18n.language === 'ar' ? 'rtl' : 'ltr'} 
      className={`min-h-screen flex flex-col ${i18n.language === 'ar' ? 'font-arabic' : 'font-bodyFont'}`}
    >
      <Header />
      {/* <HeaderBottom /> */}
      <main className="flex-grow">
        <ScrollRestoration />
        <Outlet />
      </main>
      <Footer />
      <FooterBottom />
    </div>
  );
};

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      <Route path="/" element={<Layout />}>
        {/* ==================== Header Navlink Start here =================== */}
        <Route index element={<Home />}></Route>
        <Route path="/shop" element={<Shop />}></Route>
        <Route path="/category/:_id" element={<Category />}></Route>
        <Route path="/about" element={<About />}></Route>
        <Route path="/contact" element={<Contact />}></Route>
        {/* ==================== Header Navlink End here ===================== */}
        <Route path="/offer" element={<Offer />}></Route>
        <Route path="/product/:_id" element={<ProductDetails />}></Route>
        <Route path="/cart" element={<Cart />}></Route>
        <Route path="/privacy" element={<PrivacyPolicy />}></Route>
        <Route path="/paymentgateway" element={<Payment />}></Route>
        <Route path="/order-success" element={<OrderSuccess />}></Route>
      </Route>
      <Route path="/signup" element={<SignUp />}></Route>
      <Route path="/signin" element={<SignIn />}></Route>
    </Route>
  )
);

function App() {
  const { i18n } = useTranslation();
  
  return (
    <div className={`${i18n.language === 'ar' ? 'font-arabic' : 'font-bodyFont'}`}>
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
